import React, { createContext } from 'react';

import { GetFiscalYearQuery, MonthYearPeriod, PeriodName, ProductType } from '@neo.tax/shared';

import { RdContextType } from './rd-context-provider.types';

export const RdContext = createContext<RdContextType>({
  fiscalYearId: undefined,
  fiscalYear: undefined,
  periodName: undefined,
  period: undefined,
  product: undefined,
  isNowPastPeriodEndDate: false,
});

type RdContextProviderProps = {
  children?: React.ReactNode;
  fiscalYearId: string;
  fiscalYear: GetFiscalYearQuery['getFiscalYear'];
  periodName: PeriodName;
  period: MonthYearPeriod;
  product: ProductType;
  isNowPastPeriodEndDate: boolean;
};

export const RdContextProvider = ({
  children,
  fiscalYear,
  fiscalYearId,
  isNowPastPeriodEndDate,
  period,
  periodName,
  product,
}: RdContextProviderProps): React.ReactElement => (
  <RdContext.Provider value={{ fiscalYearId, fiscalYear, periodName, period, product, isNowPastPeriodEndDate }}>
    {children}
  </RdContext.Provider>
);
